/**
 * Standard API envelope for n8n / OpenClaw and consistent client handling.
 * @typedef {Object} ApiEnvelope
 * @property {boolean} success
 * @property {object} data
 * @property {string} message
 */

/** @returns {ApiEnvelope} */
export function apiOk(data, message = '') {
  return {
    success: true,
    data: data != null && typeof data === 'object' ? data : {},
    message: message ?? '',
  };
}

/** @returns {ApiEnvelope} */
export function apiErr(message, data = {}) {
  return {
    success: false,
    data: data != null && typeof data === 'object' ? data : {},
    message: message ?? '',
  };
}

/**
 * Map a Supabase PostgREST-style single-row result into an envelope.
 * @param {{ data: object | null, error: { message?: string } | null }} result
 * @param {{ emptyMessage?: string }} [opts]
 * @returns {ApiEnvelope}
 */
export function supabaseRowToEnvelope(result, opts = {}) {
  const emptyMessage = opts.emptyMessage ?? 'No row returned';
  if (result?.error) {
    return apiErr(result.error.message || 'Request failed', { details: result.error });
  }
  if (result?.data == null) {
    return apiErr(emptyMessage, {});
  }
  return apiOk(result.data, '');
}
